import { USER_ALREADY_EXISTS } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class UserAlreadyExistsError extends ApiError {
  constructor() {
    super(USER_ALREADY_EXISTS);
  }
}
